'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCube = function IoCube(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34 13.1c0.5 0 1 0.5 1 1v14.3c0 0.7-0.5 1.3-1.1 1.7v0.1l-13.7 7.1v0.1c-0.1 0.1-0.3 0.1-0.4 0.1-0.6 0-1.1-0.5-1.1-0.9v-14.5c0-0.7 0.4-1.3 1.1-1.7l0.2-0.2 13.6-7c0.1-0.1 0.2-0.1 0.4-0.1z m-1-3.8s0.6 0.2 0.6 0.7c0 0.5-0.6 0.9-0.6 0.9l-14.5 7.6c-0.3 0.2-0.6 0.2-1 0.2s-0.7 0-1-0.2l-0.2-0.1-14.3-7.5s-0.6-0.4-0.6-0.9c0-0.5 0.6-0.7 0.6-0.7l14.2-6.4s0.8-0.4 1.3-0.4 1.3 0.4 1.3 0.4z m-17.8 11.1c0.7 0.4 1 1 1 1.7v14.5c0 0.4-0.4 0.9-1 0.9-0.1 0-0.3-0.1-0.4-0.2l-13.7-7.1v-0.1c-0.6-0.4-1.1-1-1.1-1.7v-14.3c0-0.5 0.5-1 1-1 0.2 0 0.3 0 0.4 0.1l0.2 0.1 13.3 6.9z' })
        )
    );
};

exports.default = IoCube;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/cube.js
// module id = 2241
// module chunks = 0